import { css, errorStyle } from "./SKT";

export const SKTCheckbox = ({ id, label, children, data }) => {
  const onchange = (event) => {
    data.set(id, event.target.checked);
  };
  return (
    <div
      className={css("row")}
      style={{ "padding-top": 20, "padding-bottom": 20 }}
    >
      <div className={css("col-md-4")}></div>
      <div className={css("col-md-8")}>
        <div className={css("checkbox")}>
          <label>
            <input
              id={id}
              name={id}
              type="checkbox"
              style={errorStyle(data.isValid(id))}
              onChange={onchange}
              checked={data.get(id)}
              disabled={data.get(id + "_readonly")}
            />
            {label}
            {children}
          </label>
        </div>
      </div>
    </div>
  );
};
